module.exports = __webpack_public_path__ + "img/listNull.b79582b7.png";